import { Modal, ModalWidth } from '@dreryk/react-components';

import { entitlementStatementsTranslationKeys } from '../../../translations';
import { EntitlementStatementCreateForm } from '../form/EntitlementStatementCreateForm';

export type EntitlementStatementCreateModalProps = {
   readonly patientId: number;
   readonly onCancel: VoidFunction;
   readonly onDataChanged: VoidFunction;
   readonly setEntitlementStatementId: (id: number) => void;
   readonly setPrintWithExplanationsAndNotice: (printWithExplanationsAndNotice: boolean) => void;
};

export const EntitlementStatementCreateModal = (props: EntitlementStatementCreateModalProps): JSX.Element => {
   return (
      <Modal
         title={entitlementStatementsTranslationKeys.addEntitlementStatement}
         onCloseRequest={props.onCancel}
         animateVisibility
         width={ModalWidth.WIDE}
         testId={'EntitlementStatementCreateForm'}
         shouldCloseOnEsc={false}
         shouldCloseOnOverlayClick={false}
         visible
      >
         <EntitlementStatementCreateForm {...props} />
      </Modal>
   );
};
